import axios from "axios";
import history from "./history";

export const BASE_URL = "https://api.srp.infinitysafe.com.br/";
// export const BASE_URL = "http://localhost:3334/";
export const MEDIA_URL = "http://localhost:8082/attachments/";

const api = axios.create({
    baseURL: BASE_URL,
    timeout: 120000
})

api.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response.status && history.location.pathname !== "/login") {
        // removeObject('auth');
        history.push('/login')
    } else {
        return Promise.reject(error);
    }
});

export default api;